import { PersonProjectEvent } from "services/person/event/event.types";

export type Document = {
    id: number;
    level: 'public' | 'private';
    original_filename?: string;
    observation?: string;
    label?: string;
    mime_type?: string;
    created_at?: string;
    thumb_link?: string;
    view_link?: string;
    is_my_file?: boolean;
};

export type AddDocumentPayload = {
    id: number;
    body: DocumentPayload;
};

export type DeleteDocumentPayload = {
    personId: number;
    docId: number;
};

export type DocumentPayload = {
    id: number;
    level: 'public' | 'private';
}

export type UpdateEventDocumentPayload = {
    project_id: number;
    event_id: number;
    document_id: number;
    label?: string;
    observation?: string;
};

export type UpdateEventDocumentResponse = PersonProjectEvent;

export const MIME_TYPE_LABELS: Record<string, string> = {
    'application/pdf': 'PDF',
    'image/jpeg': 'Image',
    'image/png': 'Image',
    'image/gif': 'Image',
    'application/msword': 'Document Word',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'Document Word',
    'application/vnd.ms-excel': 'Tableur Excel',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'Tableur Excel',
    'text/plain': 'Fichier texte',
    'application/zip': 'Archive ZIP'
};
